"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/themes/index.ts
var themes_exports = {};
__export(themes_exports, {
  CdoTheme: () => code_default
});
module.exports = __toCommonJS(themes_exports);

// src/themes/code.org/index.ts
var import_material = require("@mui/material");

// src/themes/code.org/constants/fonts.ts
var BARLOW_FONT = "Barlow Semi Condensed Semibold";
var FIGTREE_FONT = "Figtree";
var NOTO_FONT = "Noto Sans, Noto Sans Math, Noto Sans Arabic, Noto Sans Armenian, Noto Sans Bengali, Noto Sans SC, Noto Sans TC, Noto Sans Devanagari, Noto Sans Georgian, Noto Sans Hebrew, Noto Sans JP, Noto Sans Kannada, Noto Sans Khmer, Noto Sans KR, Noto Sans Myanmar, Noto Sans Sinhala, Noto Sans Tamil, Noto Sans Telugu, Noto Sans Thai, Noto Sans Thaana";
var createFontStack = (font, fallback) => {
  return [font, fallback, "sans-serif"].join(", ");
};

// src/themes/code.org/styleOverrides/link.ts
var LINK_OVERRIDES = {
  defaultProps: {
    variant: "body2"
  },
  styleOverrides: {
    root: ({ theme: theme2 }) => ({
      fontWeight: theme2.typography.fontWeightBold
    })
  }
};

// src/themes/code.org/styleOverrides/typography.ts
var TYPOGRAPHY_OVERRIDES = {
  defaultProps: {
    variantMapping: {
      body3: "p",
      body4: "p",
      overline1: "p",
      overline2: "p",
      overline3: "p",
      figcaption: "figcaption",
      em: "em",
      strong: "strong"
    }
  },
  styleOverrides: {
    root: () => ({
      color: "var(--text-neutral-primary)",
      // when Typography is used as a wrapper (component="div")
      "&:where(div)": {
        "& :is(p, ul, ol, li, h1, h2, h3, h4, h5, h6, span)": {
          font: "inherit",
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
          color: "inherit"
        }
      }
    }),
    gutterBottom: ({ theme: theme2 }) => ({
      "&:where(.MuiTypography-h1)": {
        marginBottom: theme2.spacing(3)
        // 24px
      },
      "&:where(.MuiTypography-h2)": {
        marginBottom: theme2.spacing(2.125)
        // 17px
      },
      "&:where(.MuiTypography-h3)": {
        marginBottom: theme2.spacing(1.75)
        // 14px
      },
      "&:where(.MuiTypography-h4)": {
        marginBottom: theme2.spacing(1.5)
        // 12px
      },
      "&:where(.MuiTypography-h5)": {
        marginBottom: theme2.spacing(1.25)
        // 10px
      },
      "&:where(.MuiTypography-h6)": {
        marginBottom: theme2.spacing(1)
        // 8px
      },
      "&:where(.MuiTypography-body1)": {
        marginBottom: theme2.spacing(2.5)
        // 20px
      },
      "&:where(.MuiTypography-body2)": {
        marginBottom: theme2.spacing(2)
        // 16px
      },
      "&:where(.MuiTypography-body3)": {
        marginBottom: theme2.spacing(1.75)
        // 14px
      },
      "&:where(.MuiTypography-body4)": {
        marginBottom: theme2.spacing(1.625)
        // 13px
      },
      "&:where(.MuiTypography-overline1)": {
        marginBottom: theme2.spacing(1.75)
        // 14px
      },
      "&:where(.MuiTypography-overline2)": {
        marginBottom: theme2.spacing(1.625)
        // 13px
      },
      "&:where(.MuiTypography-overline3)": {
        marginBottom: theme2.spacing(1.375)
        // 11px
      },
      "&:where(.MuiTypography-figcaption)": {
        marginBottom: theme2.spacing(1.75)
        // 14px
      }
    })
  }
};

// src/themes/code.org/styleOverrides/index.ts
var STYLE_OVERRIDES = {
  MuiTypography: TYPOGRAPHY_OVERRIDES,
  MuiLink: LINK_OVERRIDES
};

// src/themes/code.org/index.ts
var theme = (0, import_material.createTheme)({
  cssVariables: true,
  components: STYLE_OVERRIDES,
  typography: {
    fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
    h1: {
      fontFamily: createFontStack(BARLOW_FONT, NOTO_FONT),
      fontSize: "3rem",
      // 48px
      fontWeight: 600,
      lineHeight: 1.16
    },
    h2: {
      fontFamily: createFontStack(BARLOW_FONT, NOTO_FONT),
      fontSize: "2.125rem",
      // 34px
      fontWeight: 600,
      lineHeight: 1.24
    },
    h3: {
      fontFamily: createFontStack(BARLOW_FONT, NOTO_FONT),
      fontSize: "1.75rem",
      // 28px
      fontWeight: 600,
      lineHeight: 1.28
    },
    h4: {
      fontFamily: createFontStack(BARLOW_FONT, NOTO_FONT),
      fontSize: "1.5rem",
      // 24px
      fontWeight: 600,
      lineHeight: 1.32
    },
    h5: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "1.25rem",
      // 20px
      fontWeight: 600,
      lineHeight: 1.4
    },
    h6: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "1rem",
      // 16px
      fontWeight: 600,
      lineHeight: 1.48
    },
    body1: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "1.25rem",
      // 20px
      fontWeight: 400,
      lineHeight: 1.4
    },
    body2: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "1rem",
      // 16px
      fontWeight: 400,
      lineHeight: 1.48
    },
    body3: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.54
    },
    body4: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.813rem",
      fontWeight: 400,
      lineHeight: 1.64
    },
    overline1: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.875rem",
      // 14px
      fontWeight: 600,
      letterSpacing: "0.04rem",
      // 0.64px
      lineHeight: 1.54,
      textTransform: "uppercase"
    },
    overline2: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.813rem",
      // 13px
      fontWeight: 600,
      letterSpacing: "0.04rem",
      // 0.64px
      lineHeight: 1.64,
      textTransform: "uppercase"
    },
    overline3: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.688rem",
      // 11px
      fontWeight: 600,
      letterSpacing: "0.04rem",
      // 0.64px
      lineHeight: 1.76,
      textTransform: "uppercase"
    },
    figcaption: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.875rem",
      // 14px
      fontWeight: 600,
      lineHeight: 1.54,
      marginTop: "0.438rem"
      // 7px
    },
    strong: {
      fontWeight: 600
    },
    em: {
      fontStyle: "italic"
    }
  }
});
var code_default = theme;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CdoTheme
});
//# sourceMappingURL=index.js.map